import { render, staticRenderFns } from "./oilForm.vue?vue&type=template&id=1e0a70fe&scoped=true"
import script from "./oilForm.vue?vue&type=script&lang=js"
export * from "./oilForm.vue?vue&type=script&lang=js"
import style0 from "./oilForm.vue?vue&type=style&index=0&id=1e0a70fe&prod&scoped=true&lang=css"
import style1 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0a70fe",
  null
  
)

export default component.exports